import { COOKIES, getCookie } from "helpers/cookie";
import { getStore } from "store";
import { throttle } from "util/lodash/throttle";
import PASentry from "util/pa-sentry";
import isSpecialHoliday from "../helper/isSpecialHoliday";

function proceedToOpenChat() {
  import(/* webpackChunkName: "pa-chat-agent" */ "./PAChatAgent")
    .then((module) => {
      module.default.liveChat(window.location.pathname?.startsWith("/fr") ? "fr" : "en");
    });
}

function openLiveChatFn() {
  const { authenticationState } = getStore().getState();
  const { businessCustomer, refreshStatus } = authenticationState;

  if (isSpecialHoliday || businessCustomer) {
    return;
  }

  if (refreshStatus !== "complete") {
    console.log("Waiting for user session to be ready before opening live chat...");

    let timeoutId = null;

    // Subscribe to store updates
    const unsubscribe = getStore().subscribe(() => {
      const state = getStore().getState();
      if (state.authenticationState.refreshStatus === "complete") {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        unsubscribe();
        proceedToOpenChat();
      }
    });

    // Set a timeout in case refreshStatus never completes (10 seconds)
    timeoutId = setTimeout(() => {
      unsubscribe();
      console.log("Timeout waiting for user session to be ready");
      const cookieId = getCookie(COOKIES.CUSTOMER_BROWSER_ID);
      PASentry.logException(
        new Error("Live Chat open failed - timed out waiting for user-session"),
        null,
        { cookieId, windowCustomerBrowserId: window.customerBrowserId },
      );
    }, 10000);
  } else {
    proceedToOpenChat();
  }
}

// Wrap with throttle & throttle to 5 seconds
const openLiveChat = throttle(openLiveChatFn, 5000);

export default openLiveChat;
